import $ from 'jquery'

class MyPurchaseController {
  constructor ($stateParams, $window, $timeout) {
    'ngInject'
    this.productRef = $stateParams.productId
    this.voucherInfos = {
      'isPurchaseUsingVoucher': false
    }
    this.isFreeProduct = false
    this.iframeOnLoad = false
    this.activeTab = 'mypurchase'
    this.$window = $window
    this.disableBack = false
    this.$timeout = $timeout
  }

  isEmptyIframe () {
    let isFrame = ''
    try {
      isFrame = $('#iframe_payment').contents().find('body').html()
      if (isFrame !== '') {
        if (!this.iframeOnLoad) {
          this.$timeout(
            function () {
              document.getElementById('iframe_payment').scrollIntoView()
            }
          )
        }
        this.iframeOnLoad = true
        this.disableBack = true
        this.activeTab = 'payment'
      }
    } catch (e) {
      this.iframeOnLoad = true
      this.disableBack = true
      this.activeTab = 'payment'
    }
    $('#cardBlocSips').find('legend').trigger('click')
  }
}

export default MyPurchaseController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/my-purchase.controller.js